import { Button, Menu, MenuItem, Popover, Position } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import React from 'react';
import { useHistory } from 'react-router-dom';
import AppToaster from '../../../AppToaster';
import { LocationInfoFragment, useDeleteLocationMutation } from '../../../generated/graphql';
import { showErrorMessage } from '../../../helpers/graphql';

type LocationDetailMenuProps = {
  location: LocationInfoFragment;
  onEdit: () => void;
};

const LocationDetailMenu = ({ location, onEdit }: LocationDetailMenuProps) => {
  const history = useHistory();
  const [deleteLocation, { loading: deleting }] = useDeleteLocationMutation({
    variables: {
      id: location.id,
    },
    onCompleted: () => {
      AppToaster.success(`${location.name}  wurde in den Papierkorb gelegt`);
      history.goBack();
    },
    onError: showErrorMessage,
  });

  return (
    <>
      <Button text="Bearbeiten" icon={IconNames.EDIT} className="ml-2" onClick={onEdit} />
      <Popover
        position={Position.BOTTOM}
        content={
          <Menu>
            <MenuItem text="In den Papierkorb" icon={IconNames.TRASH} onClick={deleteLocation as any} />
          </Menu>
        }
      >
        <Button icon={IconNames.MORE} className="ml-2" loading={deleting} />
      </Popover>
    </>
  );
};

export default LocationDetailMenu;
